import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../i18n';

/**
 * Bandeau global affiché en haut quand un installateur OU un super_admin
 * est en "mode support" client.
 * Visible sur toutes les pages tant que sessionStorage.actingClientOrgId est présent.
 */
export default function SupportModeBanner() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, user } = useAuth();
  const { t } = useI18n();
  const [clientName, setClientName] = useState<string | null>(null);
  const [orgId, setOrgId] = useState<string | null>(null);

  const API = import.meta.env.VITE_WATTELZCE_API_URL || '/api/wattelzce';

  useEffect(() => {
    const id = sessionStorage.getItem('actingClientOrgId');
    const name = sessionStorage.getItem('actingClientName');
    setOrgId(id);
    setClientName(name);
  }, [location]);

  if (!orgId || !clientName) return null;

  async function exitSupport() {
    const sessionId = sessionStorage.getItem('supportSessionId');
    const isSuperAdmin = user?.platformRole === 'super_admin';

    // Close the audit session if we opened one (super_admin only)
    if (sessionId && isSuperAdmin) {
      try {
        await fetch(`${API}/api/admin/support/access/${sessionId}/end`, {
          method: 'PUT',
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch {
        /* non-blocking */
      }
    }

    sessionStorage.removeItem('actingClientOrgId');
    sessionStorage.removeItem('actingClientName');
    sessionStorage.removeItem('supportSessionId');
    navigate(isSuperAdmin ? '/admin/clients' : '/my-clients');
  }

  return (
    <div className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-6 py-2 flex items-center justify-between shadow-md sticky top-0 z-40">
      <div className="flex items-center gap-3 text-sm">
        <span className="text-lg">🛠️</span>
        <span>
          <span className="opacity-80 uppercase tracking-wide text-xs">{t('team_support_mode')}</span>
          {' · '}
          <span className="font-semibold">{clientName}</span>
        </span>
      </div>
      <button
        onClick={exitSupport}
        className="bg-white/20 hover:bg-white/30 transition-colors px-3 py-1 rounded text-xs font-medium"
      >
        ← {t('team_support_exit')}
      </button>
    </div>
  );
}
